import React from 'react';
import { IconProps } from '.';

const SvgColoredWrite = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#E0E0E4'
        d='M19.75 20.167a2.333 2.333 0 0 1-2.333 2.333H4.583a2.333 2.333 0 0 1-2.333-2.333V3.833A2.333 2.333 0 0 1 4.583 1.5h12.834a2.333 2.333 0 0 1 2.333 2.333v16.334Z'
      />
      <path
        fill='#B3B3B6'
        d='M18.28 5.802c.398-.325.988-.3 1.47.013v6.18l-.084.07-3.052 2.487H8.06c.164-.362.328-.684.52-.84l1.205-.983h7.05a.583.583 0 1 0 0-1.166h-5.62L13.45 9.74h3.383a.583.583 0 1 0 0-1.167h-1.952l2.012-1.642.059-.046 1.327-1.083ZM7.602 15.719c-.135.41-.283.893-.421 1.346l-.128.418c-.033.055-.128.22-.219.423H7.5a.583.583 0 0 1 .288 1.091c.215-.05.39-.109.441-.127l.471-.05c.852-.089 1.79-.187 2.24-.288l.147-.034c.489-.11.958-.216 1.19-.405a.02.02 0 0 0 .005-.007.017.017 0 0 1 .005-.006l2.896-2.361h-7.58ZM7.253 19.073h-.074.074Z'
      />
      <path
        fill='#AAAAB7'
        d='M8.083 18.49a.583.583 0 0 1-.583.583H5.167a.583.583 0 1 1 0-1.167H7.5c.322 0 .583.26.583.584Zm9.334-12.323c0 .322-.261.583-.584.583H5.167a.584.584 0 0 1 0-1.167h11.666c.323 0 .584.262.584.584Zm0 2.99c0 .322-.261.582-.584.582H5.167a.583.583 0 1 1 0-1.166h11.666c.323 0 .584.26.584.583Zm0 2.989c0 .322-.261.583-.584.583H5.167a.583.583 0 1 1 0-1.167h11.666c.323 0 .584.261.584.584Zm0 2.99c0 .322-.261.583-.584.583H5.167a.583.583 0 1 1 0-1.167h11.666c.323 0 .584.26.584.583Z'
      />
      <path
        fill='#888892'
        d='M16.614 14.552H12.56c-.037.081-.074.164-.11.248l-.055.122c-.083.187-.184.47-.292.797h3.08l1.432-1.167ZM7.788 18.997a.583.583 0 0 0-.288-1.09h-.666c-.151.339-.29.786-.103 1.007.094.111.26.154.448.159h.074c.177-.004.368-.037.535-.076ZM14.284 12.73h2.55a.583.583 0 1 0 0-1.168h-1.12l-1.43 1.167Z'
      />
      <path
        fill='#F2AB6D'
        d='M12.251 15.296s-.743-1.097-1.235-1.489c-.392-.492-1.487-1.234-1.487-1.234-.26-.26-.694-.28-.95-.025-.255.255-.462.796-.684 1.336-.275.669-.744 2.423-1.031 3.355-.049.16.301-.262.293-.122-.006.109.016.23.043.339l-.085.093.121.039.04.122.093-.085c.109.027.23.049.338.043.14-.008-.282.343-.122.294.932-.288 2.687-.756 3.355-1.032.539-.222 1.081-.43 1.336-.685.256-.253.237-.687-.025-.949Z'
      />
      <path
        fill='#F05046'
        d='M16.432 4.694a1.305 1.305 0 0 0 0 1.848l1.847 1.848c.511.51 1.338.51 1.848 0l1.849-1.848c.51-.51.51-1.337 0-1.848l-1.849-1.848a1.307 1.307 0 0 0-1.848 0l-1.847 1.848Z'
      />
      <path fill='#FFC700' d='m8.579 12.548 1.849 1.85 1.846 1.846 6.93-6.93-3.696-3.695-6.93 6.93Z' />
      <path fill='#363644' d='M8.257 17.756s-1.202.66-1.526.336c-.325-.326.34-1.523.34-1.523s1.137.02 1.186 1.187Z' />
      <path fill='#D1D1D3' d='m15.508 5.618 2.31-2.31 3.696 3.697-2.31 2.31-3.696-3.697Z' />
      <path
        fill='#AAAAB7'
        d='m16.893 4.232.462-.462 3.696 3.695-.462.462-3.696-3.695Zm-.923.924.461-.462 3.696 3.696-.462.462-3.695-3.696Z'
      />
    </svg>
  );
};

export default SvgColoredWrite;
